
import {routerPaths} from '../../../router/routerPaths'
import permissions from "../../../router/middleware/permissions";
import {PERMISSIONS} from "../../../staticData/permissionsStatic";

const EtsyListingsTable = () => import(/* webpackChunkName: "group-etsy-listings" */ './components/EtsyListingsTable/EtsyListingsTable.vue')
const EtsyListingsShop = () => import(/* webpackChunkName: "group-etsy-listings" */ './components/EtsyListingsShop/EtsyListingsShop.vue')
const EtsyListingsEdit = () => import(/* webpackChunkName: "group-etsy-listings" */ './components/EtsyListingsEdit/EtsyListingsEdit.vue')
const EtsyListingsCreate = () => import(/* webpackChunkName: "group-etsy-listings" */ './components/EtsyListingsCreate/EtsyListingsCreate.vue')
const moduleKey = 'etsy-listings'

export const EtsyListingsRoutes = [
  {
    path: routerPaths.mainSettingsEtsyListings,
    component: EtsyListingsTable,
    meta: {
      breadcrumbs: {
        key: [
          'mainSettings',
          'mainSettingsEtsyListings'
        ],
        items: {
          'mainSettings': {
            name: 'menu_settings',
            link: routerPaths.mainSettings,
          },
          'mainSettingsEtsyListings': {
            name: 'breadcrumbs_MyShopsEtsy',
            link: routerPaths.mainSettingsEtsyListings,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.LISTING_DOWNLOAD_GENERAL],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_MyShopsEtsy'
    },
  },
  {
    path: routerPaths.mainSettingsEtsyListingsShop,
    component: EtsyListingsShop,
    meta: {
      breadcrumbs: {
        key: [
          'mainSettings',
          'mainSettingsEtsyListings',
          'breadcrumbs_etsyListingsShop',
        ],
        items: {
          'mainSettings': {
            name: 'menu_settings',
            link: routerPaths.mainSettings,
          },
          'mainSettingsEtsyListings': {
            name: 'menu_etsyListings',
            link: routerPaths.mainSettingsEtsyListings,
          },
          'breadcrumbs_etsyListingsShop': {
            name: 'breadcrumbs_etsyListingsShop',
            link: routerPaths.mainSettingsEtsyListingsShop,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.LISTING_DOWNLOAD_GENERAL],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_etsyListingsShop'
    },
  },
  {
    path: routerPaths.mainSettingsEtsyListingsCreateListing,
    component: EtsyListingsCreate,
    meta: {
      breadcrumbs: {
        key: [
          'mainSettings',
          'mainSettingsEtsyListings',
          'mainSettingsEtsyListingsCreateListing',
        ],
        items: {
          'mainSettings': {
            name: 'menu_settings',
            link: routerPaths.mainSettings,
          },
          'mainSettingsEtsyListings': {
            name: 'menu_etsyListings',
            link: routerPaths.mainSettingsEtsyListings,
          },
          'mainSettingsEtsyListingsCreateListing': {
            name: 'breadcrumbs_NewEtsyListing',
            link: routerPaths.mainSettingsEtsyListings,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.LISTING_DOWNLOAD_GENERAL],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_NewEtsyListing'
    },
  },
  {
    path: routerPaths.mainSettingsEtsyListingsEditListing,
    component: EtsyListingsEdit,
    meta: {
      breadcrumbs: {
        key: [
          'mainSettings',
          'mainSettingsEtsyListings',
          'mainSettingsEtsyListingsEditListing',
        ],
        items: {
          'mainSettings': {
            name: 'menu_settings',
            link: routerPaths.mainSettings,
          },
          'mainSettingsEtsyListings': {
            name: 'menu_etsyListings',
            link: routerPaths.mainSettingsEtsyListings,
          },
          'mainSettingsEtsyListingsEditListing': {
            name: 'breadcrumbs_EditEtsyListing',
            link: routerPaths.mainSettingsEtsyListings,
          },
        },
      },

      middleware: [permissions],
      permissions: [PERMISSIONS.LISTING_DOWNLOAD_GENERAL],

      moduleKey: moduleKey,
      pageTitle: 'breadcrumbs_EditEtsyListing'
    },
  },
]
